import type { AnimationProps } from "framer-motion"
export type AnimationType = "fadeUp" | "fadeDown" | "scaleOut" | "scaleIn"
export const Animations = (animate: AnimationType): AnimationProps =>
  ({
    fadeUp: {
      initial: { translateY: -10 },
      animate: { translateY: 0 },
      exit: { translateY: 10 }
    },
    fadeDown: {
      initial: { translateY: 10 },
      animate: { translateY: 0 },
      exit: { translateY: -10 }
    },
    scaleOut: {
      initial: { scale: 0.98 },
      animate: { scale: 1 },
      exit: { scale: 1.02 }
    },
    scaleIn: {
      initial: { scale: 1.02 },
      animate: { scale: 1 },
      exit: { scale: 0.98 }
    }
  })[animate]
